// The legacy SaveConfiguration never overwrites: every save inserts a new history row and readers
// take the newest one, so this is an insert and there is deliberately no update mutation.
export const INSERT_KPI_CONFIGURATION_MUTATION = `
  mutation InsertKpiConfiguration($input: KpiConfigurationInsertInput!) {
    insertKpiConfiguration(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;
